import React from 'react'

const Resume = () => {
  return (
    <div>
    
    </div>
  )
}

export default Resume